import { render, staticRenderFns } from "./PopularUsers.vue?vue&type=template&id=8af723a4&scoped=true"
import script from "./PopularUsers.vue?vue&type=script&lang=ts"
export * from "./PopularUsers.vue?vue&type=script&lang=ts"
import style0 from "./PopularUsers.vue?vue&type=style&index=0&id=8af723a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af723a4",
  null
  
)

export default component.exports